/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import {Sidebar} from "primereact/sidebar";
import useForm from "../../shared/forms/useForm";
import Field from "../../shared/forms/Field";
import Form from "../../shared/forms/Form";
import moment from "moment";
import FormTabView from "../../shared/forms/Tabs/FormTabView";
import General from "./Edicion/generalSolicitudVacantes"
import {Button} from "primereact/button";
import {serialize} from "object-to-formdata";
import useApiSolicituVacante from "../../api/administracion/useApiSolicituVacante";
import solicitudVacantesCerrarValidacionEsquema from "./solicitudVacantesCerrarValidacionEsquema";
import YupValidator from "../../shared/YupValidator";
import constantes from "../../catalogos/constantes";
import {TabPanel, TabView} from "primereact/tabview";
import ReadOnlyProvider from '../../shared/forms/ReadOnlyProvider';
import ExGrid from "../../shared/Grid/ExGrid";
import ExColumn from "../../shared/Grid/ExColumn";
import {fechaUtc} from "../../shared/Grid/GridCellRenderers";
import { default as constantesCatalogos } from "../../catalogos/constantes";
import useSeguridad from "../../Seguridad/useSeguridad";
const SolicitudVacantesDetalle = ({solicitudVacanteId, onCancel, onSaved,onCerrarV, puedeEditar, onRefresh, empleado}) => {
    const validador = new YupValidator(solicitudVacantesCerrarValidacionEsquema(constantes.opciones.permisoSolicitudOperativa));
    const seguridad = useSeguridad();  
    let permisoCerrarVacante = seguridad.tieneAcceso(constantesCatalogos.opciones.permisoCierreSolicitud);
    const [mostrarOperador, setMostrarOperador] = useState(false);

    const initialValues = {
        solicituVacantes: {
            id: 0,
            fechaSolicitud: moment().startOf('day')._d
        }
    };
    const visible = solicitudVacanteId !== null;
    const [submitted, setSubmitted] = useState(false);
    const {
    values: item,
    setValues,
    onChange,
    onValidate,
    isValid
    } = useForm(initialValues);
    const [cerrarErrors, setCerrarErrors] = useState({});
    const api = useApiSolicituVacante();
       const onLoad = async () => {
        if (solicitudVacanteId === 0 || solicitudVacanteId === null) {
            setValues(initialValues);
            return;
        }

        let result = await api.obtener(solicitudVacanteId);
        console.log(result)
         const item = {
            solicituVacantes: result
        };
        setValues(item);
       
    };

    useEffect(() => {
        onLoad().then();
    }, [solicitudVacanteId]);

    const onSave = async () => {
        setSubmitted(true);

        if (!isValid)
            return;
        console.log('guardar')
        const formData = serialize(item?.solicituVacantes ?? {}, {indices: true, dotsForObjectNotation: true});
        console.log(item?.solicituVacantes)
        await api.guardar(formData);
        onSaved();
    }

  const onCerrar = async () => {
        setSubmitted(true);
        setMostrarOperador(true)
        if (await validador.validate(item?.solicituVacantes) === false) {
            setCerrarErrors(validador.errors);
            return;
        }
        const data = {
            id: 0,
            empleadoId: item.solicituVacantes.empleadoId,
            tipoOperadorId:item.solicituVacantes.tipoOperadorId,
            UnidadId:item.solicituVacantes.unidadId
        }        
        const formData = serialize(data ?? {}, {indices: true, dotsForObjectNotation: true});
        await api.cerrar(item.solicituVacantes.id,formData);
        onCerrarV();
    };

    return (
        <>
            <Sidebar visible={visible} position="right" dismissable={false}
                     className="p-sidebar-bg" onHide={onCancel} style={{ width: '1350px' }}>
                         <TabView>
                <TabPanel header={"Solicitud"}>
                            <ReadOnlyProvider >
                                <Form columns={1} values={item} onChange={onChange}
                            onValidate={onValidate} submitted={submitted} formDisabled={item?.solicituVacantes?.estatusId === constantes.estatusSolicitudVacantes.Cerrada}
                            className={`form-container full-height ${submitted ? 'submitted' : ''}`}>
                            <FormTabView>
                                <Field title="General" field={'solicituVacantes'}
                                    render={(props) =>  <General {...props}  puedeEditar={puedeEditar}  errors={cerrarErrors} submitted={submitted} mostrarOperador={mostrarOperador}  />}/>
                                                       
                        
                            </FormTabView>
                        </Form>
                        </ReadOnlyProvider>
                </TabPanel>
               
                <TabPanel header={"Historial"}>
                                    <ExGrid data={item?.solicituVacantes?.historial ?? []}>
                                        <ExColumn title={'Accion'} field={'accion'}></ExColumn>
                                        <ExColumn title={'Usuario'} field={'auditUser'}></ExColumn>
                                        <ExColumn title={'Fecha'} field={'fechaUtc'} cellRenderer={fechaUtc}></ExColumn>
                                        <ExColumn title={"Comentarios"} field={'comentarios'}></ExColumn>
                                    </ExGrid>
                                </TabPanel>
                            </TabView>
                <div className="form-footer">
                    <Button label="Salir" onClick={onCancel} className="p-button-outlined"/>
                   {permisoCerrarVacante && (item?.solicituVacantes?.estatusId !== constantes.estatusSolicitudVacantes.Cancelada && item?.solicituVacantes?.estatusId !== constantes.estatusSolicitudVacantes.Cerrada) && item.solicituVacantes?.id>0 &&
                        <Button label="Cerrar Vacante" className="p-button-outlined"
                                        type="button"
                            onClick={onCerrar}/>    
                    }
                    <Button label="Guardar" type="button"
                        onClick={onSave}/>  
                       
                </div>
            </Sidebar>
        
        </>
    );
};

export default SolicitudVacantesDetalle;
